import {
  mapApiResourceToUser,
  type PlatformUser,
  type UserApiResource,
} from '@/api/users/usersApi.types';

export interface MembershipApiResource {
  tenant_id: string | null;
  tenant_name: string | null;
  tenant_type: string | null;
  role_code: string;
  scope_code: string;
  is_owner: boolean;
}

export interface Membership {
  tenantId: string | null;
  tenantName: string | null;
  tenantType: string | null;
  roleCode: string;
  scopeCode: string;
  isOwner: boolean;
}

export interface CurrentContextApiResource {
  user: UserApiResource;
  platform_permissions: string[];
  tenant_permissions: string[];
  memberships: MembershipApiResource[];
  enabled_modules: string[];
  active_tenant_id: string | null;
  active_scope_code: string | null;
}

export interface CurrentContext {
  user: PlatformUser;
  platformPermissions: string[];
  tenantPermissions: string[];
  memberships: Membership[];
  enabledModules: string[];
  activeTenantId: string | null;
  activeScopeCode: string | null;
}

function mapApiResourceToMembership(resource: MembershipApiResource): Membership {
  return {
    tenantId: resource.tenant_id,
    tenantName: resource.tenant_name,
    tenantType: resource.tenant_type,
    roleCode: resource.role_code,
    scopeCode: resource.scope_code,
    isOwner: resource.is_owner,
  };
}

export function mapApiResourceToCurrentContext(
  resource: CurrentContextApiResource
): CurrentContext {
  return {
    user: mapApiResourceToUser(resource.user),
    platformPermissions: resource.platform_permissions,
    tenantPermissions: resource.tenant_permissions,
    memberships: resource.memberships.map(mapApiResourceToMembership),
    enabledModules: resource.enabled_modules,
    activeTenantId: resource.active_tenant_id,
    activeScopeCode: resource.active_scope_code,
  };
}
